import { createModel } from '@rematch/core';
import { Dispatch } from '../../store';
import { EncounterPatientEducation } from '../../models/encounter-patient-education';
import { storeByIMPSId } from '../../utils/converter';
import { getEncounterPatientEducations } from '../../apis/encounter-patient-education';

export interface State {
    byId: Dictionary<EncounterPatientEducation>;
    loading: Dictionary<boolean>;
}

export const encounterPatientEducations = createModel<State>({
    state: {
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<EncounterPatientEducation>>,
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        ...storeByIMPSId(data)
                    },
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: dispatch => ({
        async getEncounterPatientEducationsAsync(appointmentId: number) {
            // @ts-ignore
            const { nlmPatientEducationDefinitions } = dispatch as Dispatch;
            this.loading('getEncounterPatientEducationsAsync', true);
            try {
                const data = await getEncounterPatientEducations(appointmentId);
                this.update(data, 'getEncounterPatientEducationsAsync');

                // Collect related data
                if (data) {
                    nlmPatientEducationDefinitions.getNLMPatientEducationDefinitionsAsync(data.map(x => x.patientEducationDefinitionId));
                }
            } catch (e) {
                window.console.log(e);
                this.loading('getEncounterPatientEducationsAsync', false);
            }
        }
    })
});
